export default __webpack_public_path__ + "static/media/like-icon.378499c4.svg";